import { Query } from '@apollo/client/react/components';

import React, { useState } from 'react';
import Text from 'components/Text';

import LoadingIndicator from 'components/LoadingIndicator';
import SOCIAL_MEDIA_CROSS_POSTING_DELIVERIES from './queries/SocialMediaCrossPostingDeliveries.gql';

import { Props as SocialMediaDeliveryModalSectionProps } from './SocialMediaDeliveryModalSection';
import './DeliveryModalSection.scss';
import { SocialMediaCrossPostingDetails } from './queries/__generated__/SocialMediaCrossPostingDetails';

export type Props = {
  messageUuid: string;
  children: (props: SocialMediaDeliveryModalSectionProps) => JSX.Element;
};

function SocialMediaDeliveryModalSectionContainer({ messageUuid, children }: Props) {
  const [isFolded, setIsFolded] = useState(true);
  return (
    <Query<SocialMediaCrossPostingDetails, { messageUuid: string }>
      query={SOCIAL_MEDIA_CROSS_POSTING_DELIVERIES}
      variables={{ messageUuid }}
    >
      {({ data, error, loading }) => {
        if (loading) {
          return <LoadingIndicator />;
        }

        if (error) {
          return <Text>{`Error: ${error || 'Unknown error'}`}</Text>;
        }

        if (!data || !data.api_postSummariesByMessage) {
          return null;
        }

        if (
          data &&
          (data.api_postSummariesByMessage?.errors ||
            !data.api_postSummariesByMessage?.success ||
            !data.api_postSummariesByMessage?.socialMediaPosts)
        ) {
          return (
            <Text>{`Error: ${
              data.api_postSummariesByMessage.errors?.map((error) => error.code).join(', ') ||
              'Unknown error'
            }`}</Text>
          );
        }

        if (data.api_postSummariesByMessage.socialMediaPosts?.length === 0) {
          return null;
        }
        return children({
          isFolded,
          postDeliverySummaries: data.api_postSummariesByMessage.socialMediaPosts || [],
          toggleIsFolded: () => setIsFolded(!isFolded),
        });
      }}
    </Query>
  );
}

export default SocialMediaDeliveryModalSectionContainer;
